import config from '@/config.js'
import axios from 'axios'
import router from '@/router'
import loading from '@/utils/loading.js'

axios.defaults.withCredentials = true

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.status === 401) {
      if (router.currentRoute.name !== 'Auth') router.push({ name: 'Auth' })
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

const apiUrl = config.apiUrl

export default {
  get(endpoint, prefix = true) {
    loading.setLoading(true)
    return axios
      .get(`${!prefix ? apiUrl.replace('api/', '') : apiUrl}${endpoint}`)
      .then(response => response.data)
      .finally(() => loading.setLoading(false))
  },
  post(endpoint, payload) {
    loading.setLoading(true)
    return axios
      .post(`${apiUrl}${endpoint}`, payload)
      .then(response => response.data)
      .finally(() => loading.setLoading(false))
  },
  delete(endpoint, id) {
    loading.setLoading(true)
    return axios
      .delete(`${apiUrl}${endpoint}/${id}`)
      .then(response => response.data)
      .finally(() => loading.setLoading(false))
  },
  put(endpoint, payload) {
    loading.setLoading(true)
    return axios
      .put(`${apiUrl}${endpoint}/${payload.id}`, { payload })
      .then(response => response.data)
      .finally(() => loading.setLoading(false))
  }
}
